import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGetGroup from '../../store/action/Keygroup/FetchAll'
import ActionGet from '../../store/action/Reply/Fetch'
import ActionDelete from '../../store/action/Reply/Delete'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView, InputTypeDropdown } from '../../store/constants'
import ComboboxInput from '../PushInteractive/ComboboxInputCustom'
import {ClientId, DivisionId, PrevilageId} from "../../helper/HelperAuth";
import TextInputField from './CustomTextInput'
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Auto Reply",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            searchForm : fromJS({
                "group-id"     : 0,
                "type"   : '',
                "message"     : ''
            }),
            formSearch: fromJS({
                "search": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-12',id: 'group-id', placeholder: 'Group', label : '', defaultValue:'1', inputType: InputTypeDropdown, data: fromJS([]) },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "", field: "group-name", caption: "Group", allowSearch: true },
                { className : "", field: "reply-type", caption: "Type", allowSearch: true },
                { className : "col-sm-4", field: "caption", caption: "Caption", allowSearch: true },
                { className : "col-sm-1", field: "url", caption: "url", allowSearch: true },
                { className : "col-sm-1", field: "button", caption: "Button", allowSearch: true },
                { className : "col-sm-2", field: "option", caption: "Button Option", allowSearch: true },
                { className : "col-sm-2", cfield: "action", caption: "Actions", allowView: false },
                   
            ],
            type_id : fromJS([
                {value : 'text' , label : 'Text'},
                {value : 'media' , label : 'Media'},
                {value : 'sticker' , label : 'Sticker'},
                {value : 'button' , label : 'Button'},
                {value : 'list' , label : 'Button List'}
                
            ]),
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.keygroupall != null && props.keygroupall.size > 0){

            var newSearch = state.search;
            // eslint-disable-next-line array-callback-return
            newSearch = newSearch.map((val) => {
                if(val.get('id') === 'group-id'){
                    if(val.get('data').size === 0){
                        var options = fromJS([]);
                        var i = 0;
                        props.keygroupall.map((value) => {
                            options = options.set(i, fromJS({ 'label': value.get('group-name'), 'value': value.get('group-id') }));
                            i++;
                        });
                        val = val.set('data', options);
                    }
                }
                return val;
            }); 
            return { search: newSearch };
        }

        return null;
    }
    
    componentDidMount(){
        this.props.actionGetGroup();
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        //debugger
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        this.setState({ searchForm:formVal })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "reply-id":value.get('reply-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('caption') +' Success!', toast.POSITION.TOP_RIGHT);
            this.handleFindSearch(1);
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('caption') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm} = this.state;
        let group_id = searchForm.get('group-id');
        let type = searchForm.get('type');
        let message = searchForm.get('message');

        var bodyFInd = {};

        if (group_id === null) group_id = 0
        if (type === null) type = ""

        bodyFInd = {
            "group-id":group_id,
            "type" : type,
            "message" : message,
        }


        this.props.actionGet(page,this.state.sortForm, bodyFInd);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.data ? fromJS(this.props.data) : fromJS({});
            console.log(this.props.data)
            return (
                <CustomGrid
                    title="Auto Reply"
                    columns={ this.state.columns  } 
                    items={ items }  
                    search={ this.state.search }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGrid>
            )
        }
    }

    render(){
        const { form,searchForm, errors } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Auto reply"  : "Edit Auto Reply"  ) : "Auto Reply";
        const classHide = title == 'Auto Reply' ? 'card' : 'card hidden';
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                <div className=  {classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='group-id'
                                    value={searchForm.get('group-id')}
                                    options={fromJS({
                                        'source': this.props.keygroupall,
                                        'value': 'group-id',
                                        'label': 'group-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Group"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('group-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='type'
                                    value={searchForm.get('type')}
                                    options={fromJS({
                                        'source': this.state.type_id,
                                        'value': 'value',
                                        'label': 'label'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Type"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('type')}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <TextInputField 
                                    field='message'
                                    value={searchForm.get('message')}
                                    onChange={(field, value) => this.handleChange(field,value, '')}
                                    placeholder="Message"
                                    disabled={ false }
                                    hasError={errors.has('message')}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success content-add"
                                        onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
        data: state.user.autoreply  ,
        keygroupall: state.user.keygroupall,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionDelete: ActionDelete,
      actionGetGroup: ActionGetGroup,
  }, dispatch),
)(Page);